<template>
    <div class="page" v-if="displayInd">
        <form @keyup.enter="saveNewProfile">
            <ion-grid fixed>
                <ion-row class="row-divider"></ion-row>
                <ion-row class="rectangle">
                    <ion-col>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">
                                    Name
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line">
                                    <ion-input
                                        class="form-input"
                                        type="text"
                                        placeholder="Enter Your Name"
                                        @input="firstName = $event.target.value"
                                        :value="firstName"
                                        maxlength="200"
                                        :readonly = "readonlyInput == true ? 'true' : flase"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">
                                    Mobile Number
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line readonly">
                                    <ion-input
                                        class="form-input"
                                        type="tel"
                                        placeholder="Enter Mobile Number"
                                        @input="mobile = $event.target.value"
                                        :value="mobile"
                                    ></ion-input>
                                </div>
                            </ion-col>
                        </ion-row>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">
                                    Email Address
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line">
                                    <ion-input
                                        class="form-input"
                                        type="email"
                                        placeholder="Enter Email Address"
                                        @input="email = $event.target.value"
                                        :value="email"
                                        maxlength="200"
                                        :readonly = "readonlyInput == true ? 'true' : flase"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">
                                    State
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line select-mobile">
                                    <ion-select
                                        class="form-select popover-content"
                                        :value="state"
                                        @ionChange="state = $event.target.value"
                                        placeholder="Select State"
                                        interface="action-sheet"
                                        :disabled = "readonlyInput == true ? 'true' : flase"
                                    >
                                        <ion-select-option
                                        v-for="(state, index) in this.states"
                                        :key="index"
                                        :value="state.code"
                                        >{{state.name}}</ion-select-option>
                                    </ion-select>
                                </div>
                                <div class="border-line select-web">
                                    <select class="input-select select-s" v-model="state" placeholder="Select State" :disabled = "readonlyInput == true ? 'true' : flase">
                                        <option
                                        v-for="(state, index) in this.states"
                                        :key="index"
                                        :value="state.code"
                                        >{{ state.name }}</option>
                                    </select>
                                </div>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-toggle @click="addGstNumber">Enable GST</ion-toggle>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">GST No</ion-label>
                                <div class="border-line ">
                                    <ion-input
                                        class="form-input"
                                        type="text"
                                        @input="gstNumber = $event.target.value"
                                        :value="gstNumber"
                                        placeholder="Add GST Number"
                                        :readonly = "toggleBtn == false ? 'true' : false"
                                    ></ion-input>
                                </div>
                            </ion-col> 
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <div class= "ion-text-center" >
                                <ion-button class="btn-primary" expand="full" @click="saveNewProfile" v-if="readonlyInput == true ? false : true">Save</ion-button>
                                </div>
                            </ion-col>
                        </ion-row>
                        <ion-row class="delete-account">
                            <ion-col class="change-password" v-if="userRoleId == 4 || userRoleId == 1"> 
                                <p @click="changePassword">CHANGE PASSWORD</p>    
                            </ion-col>&nbsp;
                            <ion-col class="change-password" v-if=" userRoleId == 2 || userRoleId == 1"> 
                                <p @click="deleteAccount">DELETE ACCOUNT</p>    
                            </ion-col>
                        </ion-row>
                    </ion-col>
                </ion-row>
            </ion-grid>
            
        </form>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
    <!-- <div class="page" v-if="displayInd">
        <form @keyup.enter="saveProfile">
            <ion-grid fixed>
                <ion-row class="row-divider"></ion-row>
                <ion-row class="rectangle">
                    <ion-col>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">
                                    User Name
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line readonly">
                                    <ion-input
                                        class="form-input"
                                        type="tel"
                                        placeholder="Enter Mobile Number"
                                        @input="mobile = $event.target.value"
                                        :value="mobile"
                                        readonly="true"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">Email Address</ion-label>
                                <div class="border-line">
                                    <ion-input
                                        class="form-input"
                                        type="email"
                                        placeholder="Enter Email Address"
                                        @input="email = $event.target.value"
                                        :value="email"
                                        maxlength="200"
                                        :readonly = "readonlyInput == true ? 'true' : flase"
                                    ></ion-input>
                                </div>
                            </ion-col>
                        </ion-row>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">
                                    First Name
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line">
                                    <ion-input
                                        class="form-input"
                                        type="text"
                                        placeholder="Enter First Name"
                                        @input="firstName = $event.target.value"
                                        :value="firstName"
                                        maxlength="200"
                                        :readonly = "readonlyInput == true ? 'true' : flase"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">
                                    Last Name
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line">
                                    <ion-input
                                        class="form-input"
                                        type="text"
                                        placeholder="Enter Last Name"
                                        @input="lastName = $event.target.value"
                                        :value="lastName"
                                        maxlength="200"
                                        :readonly = "readonlyInput == true ? 'true' : flase"
                                    ></ion-input>
                                </div>
                            </ion-col>
                        </ion-row>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">
                                    Gender
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line select-mobile">
                                    <ion-select
                                        class="form-select"
                                        :value="gender"
                                        @ionChange="gender = $event.target.value"
                                        placeholder="Select Gender"
                                        interface="action-sheet"
                                        :disabled = "readonlyInput == true ? 'true' : flase"
                                    >
                                        <ion-select-option
                                        v-for="(gender, index) in this.genders"
                                        :key="index"
                                        :value="gender.code"
                                        
                                        >{{gender.description}}</ion-select-option>
                                    </ion-select>
                                </div>
                                <div class="border-line select-web">
                                    <select class="input-select" v-model="gender" placeholder="Select Gender" :disabled = "readonlyInput == true ? 'true' : flase">
                                        <option
                                            v-for="(gender, index) in this.genders"
                                            :key="index"
                                            :value="gender.code"
                                        >{{gender.description}}</option>
                                    </select>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">
                                    Date of Birth
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="date-picker-box-rc datepicker-web">
                                    <datepicker
                                        class="form-vue-picker"
                                        placeholder="DD/MON/YYYY"
                                        inputFormat="dd/MMM/yyyy"
                                        v-model="dob"
                                        :typeable="true"
                                        :disabled = "readonlyInput == true ? 'true' : flase"
                                    ></datepicker>
                                    <span class="custom-calendar-icon">
                                        <img src="/../assets/images/common/datepicker/calendar.png" />
                                    </span>
                                </div>
                                <div class="border-line datepicker-mobile">
                                    <datepicker 
                                        class="form-picker"
                                        placeholder="Select Date of birth"
                                        inputFormat="MMM dd, yyyy"
                                        v-model="dob"
                                        :typeable="true"
                                        :disabled = "readonlyInput == true ? 'true' : flase"
                                    />
                                    <span class="input-icon-calendar">
                                        <img src="/../assets/images/common/datepicker/calendar.png" />
                                    </span>
                                </div>
                            </ion-col>
                        </ion-row>
                        <ion-row align-items-stretch>
                            <ion-col class="col-padding">
                                <ion-label class="secondary-text">Address</ion-label>
                            </ion-col>
                        </ion-row>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">
                                    Building Name
                                </ion-label>
                                <div class="border-line">
                                    <ion-input
                                        class="form-input"
                                        type="text"
                                        placeholder="Enter Building Name"
                                        @input="line1 = $event.target.value"
                                        :value="line1"
                                        maxlength="100"
                                        :readonly = "readonlyInput == true ? 'true' : flase"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">
                                    Street Address
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line">
                                    <ion-input
                                        class="form-input"
                                        type="text"
                                        placeholder="Enter Street Address"
                                        @input="line2 = $event.target.value"
                                        :value="line2"
                                        maxlength="100"
                                        :readonly = "readonlyInput == true ? 'true' : flase"
                                    ></ion-input>
                                </div>
                            </ion-col>
                        </ion-row>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">
                                    Area Name
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line">
                                    <ion-input
                                        class="form-input"
                                        type="text"
                                        placeholder="Enter Area Name"
                                        @input="line3 = $event.target.value"
                                        :value="line3"
                                        maxlength="100"
                                        :readonly = "readonlyInput == true ? 'true' : flase"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">
                                    City
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line">
                                    <ion-input
                                        class="form-input"
                                        type="text"
                                        placeholder="Enter City"
                                        @input="city = $event.target.value"
                                        :value="city"
                                        maxlength="100"
                                        :readonly = "readonlyInput == true ? 'true' : flase"
                                    ></ion-input>
                                </div>
                            </ion-col>
                        </ion-row>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">
                                    State
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line select-mobile">
                                    <ion-select
                                        class="form-select popover-content"
                                        :value="state"
                                        @ionChange="state = $event.target.value"
                                        placeholder="Select State"
                                        interface="action-sheet"
                                        :disabled = "readonlyInput == true ? 'true' : flase"
                                    >
                                        <ion-select-option
                                        v-for="(state, index) in this.states"
                                        :key="index"
                                        :value="state.code"
                                        >{{state.name}}</ion-select-option>
                                    </ion-select>
                                </div>
                                <div class="border-line select-web">
                                    <select class="input-select select-s" v-model="state" placeholder="Select State" :disabled = "readonlyInput == true ? 'true' : flase">
                                        <option
                                        v-for="(state, index) in this.states"
                                        :key="index"
                                        :value="state.code"
                                        >{{ state.name }}</option>
                                    </select>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="6" class="col-padding">
                                <ion-label class="border-text" position="stacked">
                                    Pincode
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line">
                                    <ion-input
                                        class="form-input"
                                        type="text"
                                        placeholder="Enter Pincode"
                                        @input="zipcode = $event.target.value"
                                        :value="zipcode"
                                        maxlength="6"
                                        :readonly = "readonlyInput == true ? 'true' : flase"
                                    ></ion-input>
                                </div>
                            </ion-col>
                        </ion-row>
                    </ion-col>
                </ion-row>
            </ion-grid>
            <div text-center>
                <ion-button class="btn-primary" expand="full" @click="saveProfile" v-if="readonlyInput == true ? false : true">Save</ion-button>
            </div>
            <div class="spinner">
                <ion-spinner v-if="loaderTab"></ion-spinner>
            </div>
        </form>
    </div> -->
</template>

<script>
import { defineComponent } from "vue";
import datepicker from 'vue3-datepicker';
import { IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton, IonSpinner, IonToggle, alertController } from "@ionic/vue";

import moment from "moment";
import { AuthenticationService } from "../../service/account/authenticator.service";
import { ProfilerService } from "../../service/profile/profiler.service";
import { LocationService } from "../../service/location/location.service";

import { LocalStorage } from "../../data/localstorage";
import { Credential } from "../../entity/authentication/credential";
import { Profile, Gender, NewProfile } from "../../entity/authentication/profile";
import { User } from "../../entity/authentication/user";
import { Address, NewAddress } from "../../entity/location/address";
import { State } from "../../entity/location/state";

import { ValidationUtils } from "../../util/validation-utils";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import AddOTPModel from "@/views/customer/AddOTPModel.vue";


export default defineComponent ({
    name: 'userProfile',
    components: {
        datepicker, IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton, IonSpinner, IonToggle, alertController
    },
    data() {
        return {
            loaderTab: true,
            maxYear: moment()
            .add(-18, "year")
            .format(),
            genders: "",
            states: "",
            mobile: "",
            email: "",
            firstName: "",
            lastName: "",
            gender: "",
            dob: "",
            line1: "",
            line2: "",
            line3: "",
            city: "",
            state: "",
            zipcode: "",
            readonlyInput: false,
            displayInd: false,
            toggleBtn: false,
            gstNumber: "",
            displayDelete: true,
            userRoleId: ''
        }
    },
    async mounted() {
        try {
            // let genders = await new ProfilerService().genders();
            // this.genders = genders;
            let states = await new LocationService().states();
            this.states = states;
            let profile = await new ProfilerService().profileOfUser(
                new LocalStorage().user
            );
            this.userRoleId = window.localStorage.getItem("user.roleId");
            this.fillProfile(profile);
            if(this.userRoleId != 4) {
                this.readonlyInput = false;
                this.displayDelete = true;
            } else {
                this.readonlyInput = true;
                this.displayDelete = false;
            }    
            this.loaderTab = false;
            this.displayInd = true
        } catch(error) {
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        }
    },
    methods: {
        async deleteAccount() {
            // alert("Account Deleted")
            const alert = await alertController.create({
                header: "Confirm",
                message: "Are you sure want to delete?",
                buttons: [
                    {
                        text: "NO",
                        role: "cancel",
                        cssClass: "secondary",
                        handler: () => {
                            console.log('cancel')
                        }
                    },
                    {
                        text: "YES",
                        handler: () => {
                            this.deleteUserAccount();
                        }
                    }
                ]
            });
            await alert.present();
        },
        async deleteUserAccount() {
            try {
                await new ProfilerService().deleteUserAccount(new LocalStorage().user);
                new ToastUtils().presentToast("User account deleted successfully");
                this.$router.push("/logout");
            } catch (error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },
        async addGstNumber() {
            this.toggleBtn = !this.toggleBtn
            // try {
            //     alert("toggle")
            //     const modals = await modalController.create({
            //         component: AddOTPModel,

            //         methods: {
            //             dismissDialog() {
            //             modals.dismiss();
            //             },
            //         }
            //     });
            //     modals.onDidDismiss().then((data) => {
            //         alert("data" + JSON.stringify(data))
            //         // this.gstNumber = JSON.stringify(data)
            //         // if(data.role != 'backdrop') {
            //         //     if(data.data != '') {
            //         //         let res = { id: data.data, others: data.role }
            //         //         alert(JSON.stringify(res))
            //         //     }
            //         // }
            //     });
            //     return await modals.present();
            // } catch(error) {
            //     alert(error)
            //     new ToastUtils().presentToast(error.response.data.errors[0].detail);
            // }
            
        },
        changePassword() {
            this.$router.push("/customer/profile/changepassword");
        },
        fillProfile(profile) {
            this.mobile = profile.mobile;
            this.email = profile.email;
            this.firstName = profile.firstName;
            this.lastName = profile.lastName;
            this.gender = profile.gender.code;
            this.dob = profile.dob;
            this.line1 = profile.address.line1;
            this.line2 = profile.address.line2;
            this.line3 = profile.address.line3;
            this.city = profile.address.city;
            this.state = profile.address.state.code;
            this.zipcode = profile.address.zipcode;
        },
        async saveNewProfile() {
            
            try {
                if(
                    typeof this.firstName === "undefined" ||
                    this.firstName === null ||
                    this.firstName === "" ||
                    this.firstName.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Your Name");
                } else if (
                    typeof this.mobile === "undefined" ||
                    this.mobile === null ||
                    this.mobile === "" ||
                    this.mobile.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Mobile Number");
                } else if (new ValidationUtils().mobile(this.mobile) === false) {
                    new ToastUtils().presentToast("Enter Valid Mobile Number");
                } else if (
                    this.email !== "" &&
                    new ValidationUtils().email(this.email) === false
                ) {
                    new ToastUtils().presentToast("Enter Valid Email Address");
                } else if (
                    typeof this.state === "undefined" ||
                    this.state === null ||
                    this.state === ""
                ) {
                    new ToastUtils().presentToast("Select State");
                } else if(this.toggleBtn === true && (typeof this.gstNumber === "undefined" || this.gstNumber === null ||this.gstNumber === "") ) {
                    new ToastUtils().presentToast("Enter GST Number");
                } else if(this.toggleBtn === true && new ValidationUtils().validateGSTNumber(this.gstNumber) === false) {
                    new ToastUtils().presentToast("Enter Valid GST Number");
                } else {
                    this.loaderTab = true;
                    await new ProfilerService().updatedNewProfileForUser(
                        new NewProfile(
                            this.firstName.trim(),
                            this.mobile,
                            this.email,
                            new NewAddress(
                                this.toggleBtn,
                                new State(this.state),
                                this.gstNumber
                            ),
                        ),
                        new LocalStorage().user
                    );
                    this.loaderTab = false;
                    
                    new ToastUtils().presentToast("Profile updated successfully");
                    // SCMT 2.0 migration start
                    // this.$router.back();
                    // SCMT 2.0 migration end
                }
            } catch (error) {
                // new ToastUtils().presentToast(error.response.data.errors[0].detail)
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },
        async saveProfile() {
            try {
                if (
                typeof this.mobile === "undefined" ||
                this.mobile === null ||
                this.mobile === "" ||
                this.mobile.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Mobile Number");
                } else if (new ValidationUtils().mobile(this.mobile) === false) {
                    new ToastUtils().presentToast("Enter Valid Mobile Number");
                } else if (
                this.email !== null &&
                this.email.trim().length > 0 &&
                new ValidationUtils().email(this.email) === false
                ) {
                    new ToastUtils().presentToast("Enter Valid Email Address");
                } else if (
                typeof this.firstName === "undefined" ||
                this.firstName === null ||
                this.firstName === "" ||
                this.firstName.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter First Name");
                } else if (
                typeof this.lastName === "undefined" ||
                this.lastName === null ||
                this.lastName === "" ||
                this.lastName.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Last Name");
                } else if (
                typeof this.gender === "undefined" ||
                this.gender === null ||
                this.gender === ""
                ) {
                    new ToastUtils().presentToast("Select Sex");
                } else if (
                typeof this.dob === "undefined" ||
                this.dob === null ||
                this.dob === ""
                ) {
                    new ToastUtils().presentToast("Enter Date of birth");
                } else if (
                typeof this.line2 === "undefined" ||
                this.line2 === null ||
                this.line2 === "" ||
                this.line2.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Street Address");
                } else if (
                typeof this.line3 === "undefined" ||
                this.line3 === null ||
                this.line3 === "" ||
                this.line3.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Area Name");
                } else if (
                typeof this.city === "undefined" ||
                this.city === null ||
                this.city === "" ||
                this.city.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter City");
                } else if (
                typeof this.state === "undefined" ||
                this.state === null ||
                this.state === ""
                ) {
                    new ToastUtils().presentToast("Select State");
                } else if (
                typeof this.zipcode === "undefined" ||
                this.zipcode === null ||
                this.zipcode === "" ||
                this.zipcode.trim().length === 0
                ) {
                    new ToastUtils().presentToast("Enter Pincode");
                    } else {
                    this.loaderTab = true;
                    await new ProfilerService().updatedProfileForUser(
                        new Profile(
                        this.firstName.trim(),
                        this.lastName.trim(),
                        new Gender(this.gender),
                        new Date(this.dob),
                        this.mobile,
                        new Address(
                            this.line1,
                            this.line2.trim(),
                            this.line3.trim(),
                            "",
                            this.city.trim(),
                            new State(this.state),
                            this.zipcode
                        ),
                        this.email
                        ),
                        new LocalStorage().user
                    );
                    this.loaderTab = false;
                    new ToastUtils().presentToast("Profile updated successfully");
                    this.$router.back();
                }
            } catch (error) {
                this.loaderTab = false;
                // let serviceError = tryParseServiceError(error);
                // new AlertUtils().presentAlert(serviceError ? serviceError : error);
                new ToastUtils().presentToast(error.response.data.errors[0].detail)
            }
        }
    }
})
</script>

<style scoped>
.delete-account :hover {
    cursor: pointer;
}
.delete-account {
    text-align: center;
    color: #161414;
    width: 100%;
    font-size: 0.9rem;
}
.gst-input {
    height: 52px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #0000001a;
    border-radius: 12px;
    opacity: 1;
}
.change-password{
    /* border: 2px solid black; */
    background-color: #c22e2e;
    color: #ffffff;
    border-radius: 6px;
}
</style>